import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0efdd9b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-row justify-content-between"
}
const _hoisted_2 = { class: "title mb-0" }
const _hoisted_3 = {
  key: 0,
  class: "flex-shrink-0 d-flex flex-column justify-content-center"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "ps-5 mb-3"
}
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_popper = _resolveComponent("popper")!
  const _component_process_components_iterator_v2 = _resolveComponent("process-components-iterator-v2")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _mergeProps(_ctx.attributes, { class: "sub-form-container" }), [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (_, key, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "sub-form"
        }, [
          (_ctx.attributes.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex-grow-1", ['flex-grow-1 mb-6', { 'pe-2': _ctx.allowRemoveWrapper }]])
                }, [
                  _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.attributes.title) + " " + _toDisplayString(index + 1), 1)
                ], 2),
                (_ctx.allowRemoveWrapper() && !_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_popper, {
                        content: "Remover",
                        placement: "top",
                        class: "dark-popper",
                        arrow: "",
                        hover: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.removeWrapper(key)),
                            class: "btn btn-remove-icon bg-gray-600 p-2 rounded-1 text-white d-flex align-items-center justify-content-center"
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "trash" })
                          ], 8, _hoisted_4)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_process_components_iterator_v2, {
            components: _ctx.components,
            layout: _ctx.attributes.layout,
            "view-mode": _ctx.componentViewMode,
            path: `${_ctx.formRepeaterContext}.${key}`,
            "context-path": [_ctx.contextPath, key].filter(Boolean).join('.')
          }, null, 8, ["components", "layout", "view-mode", "path", "context-path"])
        ]))
      }), 128))
    ], 16),
    (!_ctx.isReadOnly)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.attributes.footerClass)
        }, [
          _createVNode(_component_popper, {
            content: "Agregar",
            placement: "top",
            class: "dark-popper",
            arrow: "",
            hover: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "btn btn-plus-icon bg-danger p-2 rounded-1 text-white d-flex align-items-center justify-content-center",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addWrapper && _ctx.addWrapper(...args))),
                disabled: !_ctx.allowAddWrappers
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "plus" })
              ], 8, _hoisted_5)
            ]),
            _: 1
          })
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.serverErrors.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serverErrors, (error, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `${_ctx.attributes.name}-error-${index}`,
              class: "text-danger fw-bold mb-0"
            }, [
              _createElementVNode("div", { innerHTML: error }, null, 8, _hoisted_7)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}